/* eslint-disable max-statements */
import React from 'react';
import styles from './styles.module.scss';
import classnames from 'classnames';
import Checkbox from 'src/Components/CheckboxV2';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { makeSelectCurrentItemData, makeSelectCurrentTotalItems } from '../selectors';
import { colorMap } from '../config';
import HeroTrophyIcon from 'src/Components/HeroTrophy';
import { webImageUri } from 'src/utils/uri';
import icSort from 'assets/svg/ic_sort.svg';
import icSortActive from 'assets/svg/ic_sort_active.svg';
import { ITEM_PER_PAGE } from '../../../constants';
import { searchAvailableHeroInventory } from 'src/redux/actions';
import PaginationControl from 'src/Components/PaginationControl_V2';
import { SearchParamsSortOption } from 'src/models';
import ImageWithPlaceholder from 'src/Components/ImageWithPlaceholder';
import Spinner from 'src/Components/Spinner';

const TableData = ({
  getTokenIdList,
  hasResetSelected,
  tokenIdsSelected,
  getTotalHeroesInventory,
  getParamsSearch,
  hasQuickSelect
}) => {
  const dispatch = useTypedDispatch();
  const [page, setPage] = React.useState(1);
  const totalItems = useTypedSelector(makeSelectCurrentTotalItems);
  const items = useTypedSelector(makeSelectCurrentItemData);
  const totalPages = Math.ceil(totalItems / ITEM_PER_PAGE);
  const [columnSorted, setColumnSorted] = React.useState(SearchParamsSortOption.GTHC_BATTLES);
  const [isDecsSorted, setIsDecsSorted] = React.useState(true);
  React.useEffect(() => {
    dispatch(searchAvailableHeroInventory({
      from: (page - 1) * ITEM_PER_PAGE,
      size: ITEM_PER_PAGE,
      market: true,
      status: 3,
      sort: columnSorted,
      desc: isDecsSorted
    }));
    getParamsSearch(columnSorted, isDecsSorted);
  }, [page, columnSorted, isDecsSorted]);
  React.useEffect(() => {
    getTotalHeroesInventory(totalItems);
  }, [totalItems]);
  const [isCheckedAll, setIsCheckedAll] = React.useState(false);
  const [itemsSelected, setItemsSelected] = React.useState([...tokenIdsSelected]);
  React.useEffect(() => {
    getTokenIdList(itemsSelected);
  }, [itemsSelected]);
  React.useEffect(() => {
    if (hasResetSelected || hasQuickSelect) setItemsSelected([]);
  }, [hasResetSelected, hasQuickSelect]);
  React.useEffect(() => {
    checkPageItemsHasSelectedAll();
  }, [itemsSelected, page, columnSorted, items]);

  const checkPageItemsHasSelectedAll = () => {
    const tokenListInPage = items.map(item => Number(item.tokenId));
    const numberTokenSelectedInPage = itemsSelected.filter(item => tokenListInPage.includes(item)).length;
    setIsCheckedAll(numberTokenSelectedInPage == items.length && numberTokenSelectedInPage > 0);
  };

  const onCheckAll = value => {
    const prevSelected = [...itemsSelected];
    const tokenListInPage = items.map(item => Number(item.tokenId));

    if (value) {
      setItemsSelected([...new Set([...prevSelected, ...tokenListInPage])]);
    } else {
      const minusSelected = prevSelected.filter(item => !tokenListInPage.includes(item));
      setItemsSelected(minusSelected);
    }
  };

  const handleSelectItem = (value, tokenId) => {
    const prev = [...itemsSelected];
    if (value && prev.indexOf(tokenId) == -1) prev.push(tokenId);else prev.splice(prev.indexOf(tokenId), 1);
    setItemsSelected(prev);
  };

  const handleClickSort = column => {
    if (column !== columnSorted) {
      setColumnSorted(column);
      setIsDecsSorted(true);
    } else setIsDecsSorted(!isDecsSorted);

    setPage(1);
  }; // eslint-disable-next-line complexity


  const renderHeader = () => /*#__PURE__*/React.createElement("div", {
    className: styles.tableHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.tableCell, styles.selectCell)
  }, /*#__PURE__*/React.createElement(Checkbox, {
    check: isCheckedAll,
    onToggle: value => onCheckAll(value)
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.tableCell, styles.heroCell)
  }, "Heroes"), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.tableCell, columnSorted == SearchParamsSortOption.HERO_RARITY ? styles.active : null),
    onClick: () => handleClickSort(SearchParamsSortOption.HERO_RARITY)
  }, "Hero Rarity", /*#__PURE__*/React.createElement("div", {
    className: styles.sortGroup
  }, /*#__PURE__*/React.createElement("img", {
    src: columnSorted == SearchParamsSortOption.HERO_RARITY && !isDecsSorted ? icSortActive : icSort,
    className: styles.icSort
  }), /*#__PURE__*/React.createElement("img", {
    src: columnSorted == SearchParamsSortOption.HERO_RARITY && isDecsSorted ? icSortActive : icSort,
    className: styles.icSortDecs
  }))), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.tableCell, columnSorted == SearchParamsSortOption.GTHC_BATTLES ? styles.active : null),
    onClick: () => handleClickSort(SearchParamsSortOption.GTHC_BATTLES)
  }, "THC battles", /*#__PURE__*/React.createElement("div", {
    className: styles.sortGroup
  }, /*#__PURE__*/React.createElement("img", {
    src: columnSorted == SearchParamsSortOption.GTHC_BATTLES && !isDecsSorted ? icSortActive : icSort,
    className: styles.icSort
  }), /*#__PURE__*/React.createElement("img", {
    src: columnSorted == SearchParamsSortOption.GTHC_BATTLES && isDecsSorted ? icSortActive : icSort,
    className: styles.icSortDecs
  }))), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.tableCell, columnSorted == SearchParamsSortOption.TROPHY_CLASS ? styles.active : null),
    onClick: () => handleClickSort(SearchParamsSortOption.TROPHY_CLASS)
  }, "Trophy Class", /*#__PURE__*/React.createElement("div", {
    className: styles.sortGroup
  }, /*#__PURE__*/React.createElement("img", {
    src: columnSorted == SearchParamsSortOption.TROPHY_CLASS && !isDecsSorted ? icSortActive : icSort,
    className: styles.icSort
  }), /*#__PURE__*/React.createElement("img", {
    src: columnSorted == SearchParamsSortOption.TROPHY_CLASS && isDecsSorted ? icSortActive : icSort,
    className: styles.icSortDecs
  }))), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.tableCell, columnSorted == SearchParamsSortOption.LEVEL ? styles.active : null),
    onClick: () => handleClickSort(SearchParamsSortOption.LEVEL)
  }, "Level", /*#__PURE__*/React.createElement("div", {
    className: styles.sortGroup
  }, /*#__PURE__*/React.createElement("img", {
    src: columnSorted == SearchParamsSortOption.LEVEL && !isDecsSorted ? icSortActive : icSort,
    className: styles.icSort
  }), /*#__PURE__*/React.createElement("img", {
    src: columnSorted == SearchParamsSortOption.LEVEL && isDecsSorted ? icSortActive : icSort,
    className: styles.icSortDecs
  }))));

  const renderTable = () => /*#__PURE__*/React.createElement(React.Fragment, null, items.map(item => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.tableRow,
      key: item.id
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.tableCell, styles.selectCell)
    }, /*#__PURE__*/React.createElement(Checkbox, {
      check: itemsSelected.includes(Number(item.tokenId)),
      onToggle: value => handleSelectItem(value, Number(item.tokenId))
    })), /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.tableCell, styles.heroCell)
    }, /*#__PURE__*/React.createElement(ImageWithPlaceholder, {
      className: styles.imgHero,
      src: webImageUri(item.avatar),
      renderPlaceholder: () => /*#__PURE__*/React.createElement(Spinner, {
        secondary: true,
        size: 33,
        className: styles.imgHero
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.infoHero
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, item.name), /*#__PURE__*/React.createElement("span", {
      className: styles.id
    }, "ID: ", item.tokenId))), /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.tableCell, styles.rarityCell, columnSorted == SearchParamsSortOption.HERO_RARITY ? styles.active : null)
    }, /*#__PURE__*/React.createElement("span", {
      className: classnames(styles[colorMap[item.rarity].color])
    }, colorMap[item.rarity].displayValue)), /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.tableCell, styles.battleCell, columnSorted == SearchParamsSortOption.GTHC_BATTLES ? styles.active : null)
    }, /*#__PURE__*/React.createElement("span", null, item.battleCap, "/", item.battleCapMax)), /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.tableCell, styles.trophyCell, columnSorted == SearchParamsSortOption.TROPHY_CLASS ? styles.active : null)
    }, /*#__PURE__*/React.createElement(HeroTrophyIcon, {
      className: styles.imgTrophy,
      value: item.trophy
    })), /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.tableCell, styles.levelCell, columnSorted == SearchParamsSortOption.LEVEL ? styles.active : null)
    }, /*#__PURE__*/React.createElement("span", null, item.level)));
  }));

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.table
  }, renderHeader(), renderTable()), /*#__PURE__*/React.createElement(PaginationControl, {
    className: styles.paging,
    totalPages: totalPages,
    page: page,
    onPageChange: page => setPage(page)
  }));
};

export default TableData;